import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import LoadingSpinner from 'components/LoadingSpinner';

import MenuControls from 'components/Widget/components/menus/MainSettings/components/MenuControls';
import { Message } from 'components/shared';

const useStyles = makeStyles({
  root: {
    flexGrow: 1
  },
  rootInput: {
    '& .MuiOutlinedInput-input': {
      padding: '15px 14px'
    }
  },
  modal_subtitle: {
    marginBottom: '30px'
  }
});
const ResetDashboardSetPopup = ({ resetSubmit, state, onClose }) => {
  const classes = useStyles();

  const { isLoading, isError, error } = state;

  return (
    <>
      <h2>Are you sure you want to reset the dashboard set ?</h2>
      <Typography className={classes.modal_subtitle} gutterBottom>
        All of your changes to this object dashboard set will be permanently removed.
      </Typography>

      {isLoading && <LoadingSpinner />}

      {isError && <Message type="error" text={error} />}

      <Box style={{ marginLeft: '-23px' }} mt={6}>
        <MenuControls handleClose={onClose} useFormSubmit={false} onSubmit={resetSubmit} />
      </Box>
    </>
  );
};

ResetDashboardSetPopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  resetSubmit: PropTypes.func.isRequired,
  state: PropTypes.shape({
    isLoading: PropTypes.bool,
    isError: PropTypes.bool,
    error: PropTypes.string,
    data: PropTypes.shape({})
  })
};

ResetDashboardSetPopup.defaultProps = {
  state: {}
};

export default ResetDashboardSetPopup;
